<template>
    <b-col align="center" class="feature" lg="3" md="3" sm="6">
        <div class="feature-item">
            <b-img v-if="featurePic" fluid :src="featurePic" class="feature-pic"/>
            <span class="feature-three-dots" v-else>...</span>
        </div>
        <div class="feature-title">
            <slot></slot>
        </div>
    </b-col>
</template>

<script>
    export default {
        name: "PmisFeatureItem",
        props: [ "pic", "top" ],
        computed: {
            featurePic() {
                if (this.pic) {
                    return "./pic/igrala/" + this.pic + ".png";
                }
                return null;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .feature {
        //padding: 20px;
        padding-bottom: 10px;
        padding-top: 10px;
    }
    .feature-item {
        border-color: lightgrey;
        border-radius: 15px;
        border-style: solid;
        border-width: 0.5px;
        background-color: white;
        heigth: 100px;
        display: flex;
        justify-content: center;
        max-width: 120px;
        padding: 12px;
    }
    .feature-title {
        margin-top: 10px;
        text-align: center;
        color: $pmis-grey;
        font-size: 12px;
    }

    .feature-pic {
        max-height: 70px;
    }

    .feature-three-dots {
        font-size: 3em;
        width: 100%;
    }
</style>
